import React, { useState } from 'react';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';

const SiteFilterForm = ({
  applyFilter,
  siteTypes = [],
  agenda= [],
  assignedAreas = [],
  reportees = [],
  siteStatus = []
}) => {
  const filterInputs = {
    site_no: '',
    client_name: '',
    // site_type: '',
    // area_id: '',
    // reportee: '',
    // status_id: '',
    agenda:''
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
      }}
    >
      <ConstantInput
        label={localization.siteNumber}
        value={filterFieldsData.site_no}
        regex={Regex.number.test(filterFieldsData.site_no)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, site_no: val })
        }
      />
      <ConstantInput
        label={localization.clientName}
        value={filterFieldsData.client_name}
        regex={Regex.text.test(filterFieldsData.client_name)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, client_name: val })
        }
      />
       {agenda.length !== 0 ? 
        <>
          <DropDownInput
              disabled={siteTypes.length === 0}
              label={localization.meetingAgenda}
              data={agenda}
              getIdValue={(val) =>
                setFilterFieldsData({ ...filterFieldsData, agenda: val.id })
              }
            />
          <ConstantInput
            label='BA Name'
            value={filterFieldsData.ba_name}
            regex={Regex.text.test(filterFieldsData.ba_name)}
            type="text"
            handleChange={(val) =>
              setFilterFieldsData({ ...filterFieldsData, ba_name: val })
            }
          />
        </>
        : ''}
    {/* {siteTypes.length !== 0 ? 
    
    <DropDownInput
        disabled={siteTypes.length === 0}
        label={localization.siteType}
        data={siteTypes}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, site_type: val.id })
        }
      />
    : ''} */}
      {/* {siteStatus.length !== 0 ? 
      <DropDownInput
      disabled={siteStatus.length === 0}
      label={localization.siteStatus}
      data={siteStatus}
      getIdValue={(val) =>
        setFilterFieldsData({ ...filterFieldsData, status_id: val.id })
      }
    />
      : ''} */}
      
      {/* {assignedAreas.length !== 0 ? 
      <DropDownInput
      disabled={assignedAreas.length === 0}
      label={localization.assignedArea}
      data={assignedAreas}
      getIdValue={(val) =>
        setFilterFieldsData({ ...filterFieldsData, area_id: val.id })
      }
    />
      : ''} */}
      {/* {reportees.length !== 0 ? <DropDownInput
        disabled={reportees.length === 0}
        label={localization.reportee}
        data={reportees}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, reportee: val.id })
        }
      /> : ''} */}
      
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            applyFilter(filterInputs);
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default SiteFilterForm;
